export default "/images/product-detail-variant-check.png";